import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { translations } from "./translations";

// Build react-i18next resources from the existing translation dictionaries.
const resources = {
  en: { translation: translations.en },
  pt: { translation: translations.pt },
  fr: { translation: translations.fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Region-dependent detection: navigator gives e.g. "pt-BR" / "fr-FR";
    // `load: languageOnly` strips the region so "pt-BR" resolves to "pt".
    // Anything unsupported falls back to English.
    fallbackLng: "en",
    supportedLngs: ["en", "pt", "fr"],
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      // Persist the user's choice; auto-detect from the browser on first visit.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "venka_lang",
      caches: ["localStorage"],
    },
    keySeparator: ".",
    nsSeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnEmptyString: false,
  });

export default i18n;
